import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Container,
  Tabs,
  Tab,
  Form,
  Dropdown,
  ButtonGroup,
  OverlayTrigger,
  Button,
  Popover
} from "react-bootstrap";
import search from "assets/search.svg";
import ordination from "assets/arrow_up_down.svg";
import filterIcon from "assets/filter.svg";
import add from "assets/add.svg";
import down from "assets/download.svg";

import azAsc from "assets/azAsc.svg";
import azDesc from "assets/azDesc.svg";
import ordenacaoAsc from "assets/ordernacaoasc.svg";
import ordenacaoDesc from "assets/ordenacaodesc.svg";

import "./styles.css";
import Icon from "components/Icon";

const ActionBar = props => {
  const {
    include,
    ComplementsTab,
    handleSelect,
    title,
    handleOrder,
    orderArray, //array de objetos
    handleFilter,
    newConsult,
    filterArray, //array de objetos
    handleReset,
    handleSearch,
    handleDownload,
    goBack
  } = props;

  const [value, setValue] = useState();
  const [filterValue, setFilterValue] = useState();
  const [filter, setFilter] = useState();

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        if (filter && typeof handleFilter === "function") {
          handleFilter(filter, filterValue);
        } else if (typeof handleSearch === "function") handleSearch(value);
      }
    };

    document.addEventListener("keydown", listener);

    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [filter, filterValue, handleFilter, handleSearch, value]);

  return (
    <Container fluid className="px-0 " id="action_bar">
      <div className="action-bar">
        {goBack && (
          <div className="action-bar__goBack">
            <Icon
              name="arrow_back_ios_new"
              id="action-bar__goBack--Icon"
              onClick={() => {
                handleReset();
              }}
            />
          </div>
        )}

        <Col md={5} className="p-0 m-auto">
          {title && <div className="action-bar__title">{title}</div>}
          {ComplementsTab && (
            <Tabs
              id="complements"
              defaultActiveKey="ComplementsGroup"
              onSelect={k => handleSelect(k)}
            >
              <Tab
                eventKey="ComplementsGroup"
                title="Grupos de Complementos"
              ></Tab>
              <Tab eventKey="Complements" title="Complementos"></Tab>
            </Tabs>
          )}
        </Col>
        <Col md={6} className="d-flex justify-content-end flex-row p-0">
          {handleSearch && (
            <Col className="p-0 d-flex flex-row align-items-center action_bar_search">
              <OverlayTrigger
                trigger="click"
                key="bottom-end"
                rootClose
                placement="bottom-end"
                overlay={
                  <Popover id={`action_bar_search_popover`}>
                    <Popover.Content>
                      <Form.Control
                        className="action_bar_search__buttom--input"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        placeholder="buscando por?"
                        onChange={event => {
                          setValue(event.target.value);
                        }}
                      />
                    </Popover.Content>
                  </Popover>
                }
              >
                <Button
                  size="lg"
                  className="action_bar_search__buttom d-flex flex-row"
                >
                  <img src={search} alt="icon" />{" "}
                  <div className="action_bar_search__buttom--title">Buscar</div>
                </Button>
              </OverlayTrigger>
            </Col>
          )}
          {handleOrder && (
            <Col className="p-0 d-flex flex-row align-items-center justify-content-end action_bar_order">
              <Dropdown>
                <Dropdown.Toggle
                  bsPrefix={"btn-group"}
                  as={ButtonGroup}
                  id="order-dropdown"
                >
                  <Button
                    size="lg"
                    className="action_bar_order__buttom d-flex flex-row p-2"
                  >
                    <img src={ordination} alt="icon" />
                    <div className="action_bar_order__buttom--title">
                      Ordenar
                    </div>
                  </Button>
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ marginTop: "5px", marginLeft: "3px" }}>
                  {orderArray &&
                    orderArray.map((orderby, index) => {
                      return (
                        <>
                          <Dropdown.Item
                            className="pr-3"
                            eventKey={`${index}a`}
                            onClick={() => {
                              handleOrder({
                                order: orderby.value,
                                order_by_direct: "asc"
                              });
                            }}
                          >
                            <Row className="d-flex justify-content-end pl-0">
                              <div>{orderby.field}</div>
                              <img
                                src={
                                  orderby.type === "string"
                                    ? azAsc
                                    : ordenacaoAsc
                                }
                                alt="asc"
                              />
                            </Row>
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="pl-0 pr-3"
                            eventKey={`${index}b`}
                            onClick={() => {
                              handleOrder({
                                order: orderby.value,
                                order_by_direct: "desc"
                              });
                            }}
                          >
                            <Row className="d-flex justify-content-end">
                              <div>{orderby.field}</div>{" "}
                              <img
                                src={
                                  orderby.type === "string"
                                    ? azDesc
                                    : ordenacaoDesc
                                }
                                alt="desc"
                              />
                            </Row>
                          </Dropdown.Item>
                        </>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
          {newConsult && (
            <Col className="p-0 d-flex flex-row align-items-center justify-content-end action_bar_filter">
              <Button
                size="lg"
                className="action_bar_filter__buttom d-flex flex-row p-2"
                onClick={() => {
                  handleReset();
                }}
              >
                <Icon name="search" id="action_bar_newConsult" />
                <div className="action_bar_filter__buttom--title">
                  Nova Consulta
                </div>
              </Button>
            </Col>
          )}
          {handleFilter && (
            <Col className="p-0 d-flex flex-row align-items-center justify-content-end action_bar_filter">
              <Button
                size="lg"
                className="action_bar_filter__buttom d-flex flex-row p-2"
                onClick={() => handleFilter()}
              >
                <img src={filterIcon} alt="icon" />
                <div className="action_bar_filter__buttom--title">
                  Filtros Avançados
                </div>
              </Button>
            </Col>
          )}
          {(handleDownload || include) && (
            /*<Col
              md={handleDownload ? 2 : 1}
              className="d-flex  flex-row align-items-center justify-content-end action_bar_handleDownload"
            >
              <div className="action-bar__divisor"></div>
              {handleDownload && (
                <div className="image-down " onClick={handleDownload}>
                  <img src={down} alt="icon" />
                  Exportar para Excel
                </div>
              )}
              {include && (
                <div className="image-add" onClick={include}>
                  <img src={add} alt="icon" style={{ width: 12, height: 12 }} />
                </div>
              )}
            </Col>*/
            <>
              <div className="action-bar__divisor"></div>

              <Col className="p-0 d-flex flex-row align-items-center justify-content-end action_bar_filter">
                <Button
                  size="lg"
                  className="action_bar_filter__buttom d-flex flex-row p-2"
                  onClick={() => handleDownload()}
                >
                  <Icon name="download" id="export_excel" />
                  <div className="action_bar_filter__buttom--title">
                    {window.screen.width <= 650
                      ? "Exportar"
                      : "Exportar para Excel"}
                  </div>
                </Button>
              </Col>
            </>
          )}
        </Col>
      </div>
    </Container>
  );
};

ActionBar.propTypes = {
  include: PropTypes.any,
  title: PropTypes.string,
  ComplementsTab: PropTypes.any,
  handleSelect: PropTypes.func,
  handleOrder: PropTypes.func,
  orderArray: PropTypes.array, //array de objetos
  handleFilter: PropTypes.func,
  filterArray: PropTypes.array, //array de objetos
  handleSearch: PropTypes.func,
  handleDownload: PropTypes.func
};

export default ActionBar;
